import { Flex } from 'foundations-components/components/Flex';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { AILoader } from 'ai-components-ui-library/components/loading/AILoader';
import { useGTKMDomainHelperTextKey } from '../../hooks/useGTKMDomainHelperText';
import { isAssignedToGTKMExperiment } from '../../utils/gtkm/isAssignedToGTKM';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SidePanelCompanyDomainLoading = () => {
  const {
    isGTKMAnimationRunning,
    copyMessageKey
  } = useGTKMDomainHelperTextKey();
  const isAssignedToGTKM = useSelector(isAssignedToGTKMExperiment);
  const AnimationNotLoadedForGTKM = isAssignedToGTKM && !isGTKMAnimationRunning;
  if (!isAssignedToGTKM || AnimationNotLoadedForGTKM) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    "data-test-id": "company-domain-footer",
    gap: "100",
    justifyContent: "center",
    marginBlockEnd: "auto",
    marginBlockStart: "auto",
    marginInlineEnd: "400",
    children: [/*#__PURE__*/_jsx(AILoader, {
      isFinished: !isGTKMAnimationRunning,
      size: "xs"
    }), /*#__PURE__*/_jsx(Text, {
      as: "small",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: copyMessageKey
      })
    })]
  });
};
export default SidePanelCompanyDomainLoading;